import IndexMain from './IndexMain.vue'

import { createApp } from './main-template'
createApp(IndexMain)
